import * as actions from '../actions';
import { globalGetService, globalPostService, globalPutService } from '../../../../globalServices/';
import { toastFlashMessage } from '../../../../utils/';
import { trackActivity } from '../../../../utils/mixpanel';
import { addQfdMntEvent } from '../../contractAddObject';

export const contrQfdMntEventListAc = (params) => {
  return (dispatch) => {
    dispatch({
      type: actions.QFD_MNT_LOADER,
      payload: true
    });
    globalGetService('contracts/'+params.contract_slug+'/qualified-maintenance-events/', {})
    .then(response => {
      dispatch({
        type: actions.QFD_MNT_LOADER,
        payload: false
      });
      if(response.data.statusCode == 200){
        dispatch({
          type: actions.CONTR_QFT_MNT_EVENT_LIST,
          payload: response.data.data
        });
      }
    });
  }
}
export const qfdMaintenanceEventCrudAc = (params, type, id) => {
  return(dispatch) => {
    if(type == 'add'){
      dispatch({
        type: actions.QFT_MNT_COND_CRUD,
        payload: {type: type, data:addQfdMntEvent , flag: true }
      });
    }else{
      dispatch({
        type: actions.QFD_MNT_LOADER,
        payload: true
      });
      globalGetService('contracts/'+params.contract_slug+'/qualified-maintenance-events/' + id + '/', {})
      .then(response => {
        dispatch({
          type: actions.QFD_MNT_LOADER,
          payload: false
        });
        if(response.data.statusCode == 200){
          dispatch({
            type: actions.QFT_MNT_COND_CRUD,
            payload: {type: 'view', data: response.data.data, flag: true }
          });
        }
      })
    }
  }
}

export const reseverAcntListAc = (params) => {
  return (dispatch) => {
    globalGetService('contracts/'+params.contract_slug+'/reserve-accounts/', {})
    .then(response => {
      dispatch({
        type: actions.RESERVE_ACNT_LIST,
        payload: response.data.data
      });
    });
  }
}

export const addEditQfdMntEventAc = (params, data, type, assetViewId) => {
  return (dispatch) => {
    dispatch({
      type: actions.QFD_MNT_LOADER,
      payload: true
    });
    if(type == 'add'){
      globalPostService('contracts/'+params.contract_slug+'/qualified-maintenance-events/', data)
      .then(response => {
        dispatch({
          type: actions.QFD_MNT_LOADER,
          payload: false
        });
        if(response.data.statusCode == 200){
          dispatch({
            type: actions.ADD_QFT_MNT_EVENT_SUCCESS,
            payload: response.data.data
          });
          dispatch({
            type: actions.QFT_MNT_COND_CRUD,
            payload: {type: '', data:{} , flag: false }
          });
          toastFlashMessage(response.data.message, 'success');
          let assetTypeNames = {
            3: 'APU',
            4: 'LG',
            5: 'PROPELLER'
          }
          trackActivity('Item Added', {
            page_title: `Quality Maintenance Events`,
            application_module: `Contracts`,
            asset: assetViewId.asset_type === 1 ? `MSN ${assetViewId.msn}` : [3,4,5].includes(assetViewId.asset_type) ? `${assetTypeNames[assetViewId.asset_type]} ${assetViewId.serial_number}` : `ESN ${assetViewId.esn}`,
            contract_slug: params.contract_slug,
            item_type: `Quality Maintenance Events`,
            item_id: response.data.data.id
          })
        }
      })
    }else{
      globalPutService('contracts/'+params.contract_slug+'/qualified-maintenance-events/' + data.id + '/', data)
      .then(response => {
        dispatch({
          type: actions.QFD_MNT_LOADER,
          payload: false
        });
        if(response.data.statusCode == 200){
          dispatch({
            type: actions.EDIT_QFT_MNT_EVENT_SUCCESS,
            payload: response.data.data
          });
          dispatch({
            type: actions.QFT_MNT_COND_CRUD,
            payload: {type: '', data:{} , flag: false }
          });
          toastFlashMessage(response.data.message, 'success');
          let assetTypeNames = {
            3: 'APU',
            4: 'LG',
            5: 'PROPELLER'
          }
          trackActivity('Item Edited', {
            page_title: `Quality Maintenance Events`,
            application_module: `Contracts`,
            asset: assetViewId.asset_type === 1 ? `MSN ${assetViewId.msn}` : [3,4,5].includes(assetViewId.asset_type) ? `${assetTypeNames[assetViewId.asset_type]} ${assetViewId.serial_number}` : `ESN ${assetViewId.esn}`,
            contract_slug: params.contract_slug,
            item_type: `Quality Maintenance Events`,
            item_id: data.id
          })
        }
      })
    }
  }
}
